import Badge from './Badge';

export default Badge;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/badge/index.js
// module id = 335
// module chunks = 0